module.exports = __webpack_public_path__ + "img/video.cc0a692a.png";